import { Directive, EventEmitter, Input, Output } from '@angular/core';

import type { InsertPlaceholderInputDirective } from './insert-placeholder-input.directive';

@Directive({
  standalone: true,
  selector: '[insertPlaceholder]',
  host: {
    '(mousedown)': 'insert($event)',
  },
})
export class InsertPlaceholderDirective {
  @Input('insertPlaceholder') public placeholder: string;
  @Input('insertPlaceholderTarget') public target: InsertPlaceholderInputDirective;
  @Input() public disabled: boolean = false;

  @Output() public mouseDown: EventEmitter<MouseEvent> = new EventEmitter();

  public insert($event: MouseEvent): void {
    if (this.disabled) {
      $event.stopPropagation();
      $event.preventDefault();
      return;
    }
    if (this.target) {
      $event.stopPropagation();
      $event.preventDefault();
      this.target.insert(this.placeholder);
    }
    this.mouseDown.emit($event);
  }
}
